<script setup>
import { ref, computed } from "vue";
import { Bell } from "lucide-vue-next";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";

const initialNotifications = [

];

const notifications = ref(initialNotifications);
const unreadCount = computed(() => notifications.value.filter((n) => n.unread).length);

const markAllAsRead = () => {
  notifications.value = notifications.value.map((notification) => ({ ...notification, unread: false }));
};

const markAsRead = (id) => {
  notifications.value = notifications.value.map((notification) =>
    notification.id === id ? { ...notification, unread: false } : notification
  );
};
</script>

<template>
  <Popover>
    <PopoverTrigger asChild>
      <div class="relative">
        <Button size="icon" variant="ghost" class=" rounded-full relative" aria-label="Open notifications">
          <Bell size="16" stroke-width="2" aria-hidden="true" />
        </Button>
        <Badge variant="secondary" v-if="unreadCount > 0" class="text-xs size-4 flex items-center justify-center absolute -right-3 -top-0 min-w-4 -translate-x-1/2 px-px">
          {{ unreadCount > 99 ? "99+" : unreadCount }}
        </Badge>
      </div>
    </PopoverTrigger>
    <PopoverContent class="w-80 p-1" align="end">
      <div class="flex items-baseline justify-between gap-4 px-3 py-2">
        <div class="text-sm font-semibold">Notifications</div>
        <button v-if="unreadCount > 0" class="text-xs font-medium hover:underline" @click="markAllAsRead">
          Mark all as read
        </button>
      </div>
      <div role="separator" aria-orientation="horizontal" class="-mx-1 my-1 h-px bg-border"></div>
      <div v-if="notifications.length === 0" class="text-center text-muted-foreground py-10">
        No notifications
      </div>
      <div v-for="notification in notifications" :key="notification.id" class="rounded-md px-3 py-2 text-sm transition-colors hover:bg-accent">
        <div class="relative flex items-start">
          <div class="flex-1 space-y-1">
            <button class="text-left text-foreground/80 relative" @click="markAsRead(notification.id)">
              <span class="font-medium text-foreground hover:underline">{{ notification.user }}</span>
              {{ notification.action }}
              <span class="font-medium text-foreground hover:underline">{{ notification.target }}</span>.
            </button>
            <div class="text-xs text-muted-foreground">{{ notification.timestamp }}</div>
          </div>
          <div v-if="notification.unread" class="absolute end-0 self-center">
            <span class="sr-only">Unread</span>
            <svg width="6" height="6" fill="currentColor" viewBox="0 0 6 6" aria-hidden="true">
              <circle cx="3" cy="3" r="3" />
            </svg>
          </div>
        </div>
      </div>
    </PopoverContent>
  </Popover>
</template>
